import { useEffect, useState } from "react";

export const DESKTOP_POINTER_QUERY = "(hover: hover) and (pointer: fine)";

export default function useDesktopPointer() {
  const [interactive, setInteractive] = useState(false);

  useEffect(() => {
    const query = window.matchMedia?.(DESKTOP_POINTER_QUERY);
    if (!query) return;
    const update = () => setInteractive(query.matches);
    update();
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);

  return interactive;
}
